/** @jsx jsx */
import { Fragment } from 'react';
import { jsx } from '@emotion/core';
import NavLink from './NavLink';
import { HeaderNav } from '@zapier/product-dev-platform/src/types';

type CtaLinksProps = {
  links: HeaderNav;
};

const navCss = {
  display: 'none',
  ul: {
    margin: 0,
    padding: 0,
  },
  '@media (min-width: 1079px)': {
    display: 'flex',
    alignSelf: 'stretch',
    alignItems: 'center',
    borderLeft: '1px solid rgba(255, 255, 255, 0.1)',
    padding: '0 12px',
    ul: {
      display: 'flex',
    },
    li: {
      listStyle: 'none',
      display: 'block',
      margin: '0 12px',
    },
  },
};

const CtaLinks: React.FC<CtaLinksProps> = props => (
  <Fragment>
    <nav aria-label="CTA navigation" css={navCss}>
      <ul>
        {props.links.map(link => (
          <li key={link.label}>
            <NavLink
              href={link.href}
              isActive={link.isActive}
              label={link.label}
            />
          </li>
        ))}
      </ul>
    </nav>
  </Fragment>
);

CtaLinks.defaultProps = {
  links: [],
};
export default CtaLinks;
